import AuthModal from 'common/components/AuthModal';
import UserStore from 'launch/stores/UserStore';
import BriefStore from 'launch/stores/BriefStore';
import connectToStores from 'fluxible-addons-react/connectToStores';
import { dismissAuthModal } from 'launch/actions/authActions';
import PropTypes from 'prop-types';

export default connectToStores(
    AuthModal,
    [UserStore, BriefStore],
    context => {
        const userStore = context.getStore(UserStore);
        const briefStore = context.getStore(BriefStore);

        return {
            isVisible: userStore.isAuthModalVisible(),
            email: briefStore.briefData.email,
            onDismiss: () => {
                context.executeAction(dismissAuthModal);
            },
            onAuthenticationSuccess: () => {
                // Until we can takeover global nav and render it ourselves,
                // a full page reload is required
                window.location.reload();
            },
        };
    },
    {
        executeAction: PropTypes.func.isRequired,
    }
);



// WEBPACK FOOTER //
// ./js/launch/components/AuthModal.jsx